import axiosInstance from '../../../lib/axios';
import type {
  CatalogResult,
  CreateTrackedFeatureInput,
  FeatureKind,
  FeatureUsageParams,
  FeatureUsageReport,
  TrackedFeature,
  TrackedFeatureFilter,
  TrackedFeatureList,
  UpdateTrackedFeatureInput,
  UserFeatureUsageReport,
} from './types';

const BASE_URL = '/v1/admin/feature-tracking';

export const getDashboardFeatureUsage = async (
  params: FeatureUsageParams
): Promise<FeatureUsageReport> => {
  const response = await axiosInstance.get<{ data: FeatureUsageReport }>(
    '/v1/admin/dashboard/feature-usage',
    { params }
  );
  return response.data.data;
};

export const getUserFeatureUsage = async (
  publicId: string,
  params: FeatureUsageParams
): Promise<UserFeatureUsageReport> => {
  const response = await axiosInstance.get<{ data: UserFeatureUsageReport }>(
    `/v1/admin/users/${publicId}/feature-usage`,
    { params }
  );
  return response.data.data;
};

export const listTrackedFeatures = async (
  filter: TrackedFeatureFilter
): Promise<TrackedFeatureList> => {
  const response = await axiosInstance.get<{ data: TrackedFeatureList }>(`${BASE_URL}/features`, {
    params: filter,
  });
  return response.data.data;
};

export const getFeatureCatalog = async (params: {
  kind?: FeatureKind;
  q?: string;
  limit?: number;
}): Promise<CatalogResult> => {
  const response = await axiosInstance.get<{ data: CatalogResult }>(`${BASE_URL}/catalog`, {
    params,
  });
  return response.data.data;
};

export const createTrackedFeature = async (
  input: CreateTrackedFeatureInput
): Promise<TrackedFeature> => {
  const response = await axiosInstance.post<{ data: TrackedFeature }>(
    `${BASE_URL}/features`,
    input
  );
  return response.data.data;
};

export const updateTrackedFeature = async (
  publicId: string,
  input: UpdateTrackedFeatureInput
): Promise<TrackedFeature> => {
  const response = await axiosInstance.patch<{ data: TrackedFeature }>(
    `${BASE_URL}/features/${publicId}`,
    input
  );
  return response.data.data;
};

export const deleteTrackedFeature = async (publicId: string): Promise<void> => {
  await axiosInstance.delete(`${BASE_URL}/features/${publicId}`);
};
